import { render, staticRenderFns } from "./edit-channel-dialog.vue?vue&type=template&id=3a68b7cf&scoped=true&"
import script from "./edit-channel-dialog.vue?vue&type=script&lang=ts&"
export * from "./edit-channel-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./edit-channel-dialog.vue?vue&type=style&index=0&id=3a68b7cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a68b7cf",
  null
  
)

export default component.exports